import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import {TareasApiService} from '../../../../service/api/tareas-api.service';
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {BaseView} from '../../../base-view';
import moment, { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { Filtering } from 'src/app/service/filtering/filtering';
import {StorageManager} from '../../../../common/storage-manager.class';

import type { OnInit, AfterViewInit } from '@angular/core';
import { TareaLimpiezaGeneralModel } from 'src/app/models/tareas/tarea-limpieza-general.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { TareasMtoLimpiezaGeneralFormDefinition } from './tareas-mto-limpieza-general-form/form-control/form-definition';

const TRUTHY_VALUES = [1, '1', true, 'true'];
@Component({
    selector: 'app-tareas-mto-limpieza-general',
    standalone: false,
    templateUrl: './tareas-mto-limpieza-general.component.html',
    styleUrls: ['./tareas-mto-limpieza-general.component.scss']
})

export class TareasMtoLimpiezaGeneralComponent extends BaseView<TareaLimpiezaGeneralModel> implements OnInit, AfterViewInit {

    public rolUser = StorageManager.getUser().rol;
    public hiddenButtonDelete = false;

    public appName = environment.appName;
    public fincaName = environment.features.fincaName; 
    public hasClients = environment.features.hasClients;
    public serverUrl = environment.serverUrl;
    public userCanSeeClientes = this.hasClients &&
  (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));     

    public getRequest: RequestHandler<TareaLimpiezaGeneralModel[]> = this.tareasApi.mtoLimpiezaGeneral.GET;
    public deleteRequest: RequestHandler<TareaLimpiezaGeneralModel> = this.tareasApi.mtoLimpiezaGeneral.DELETE;
    public pathToForm = 'limpieza-general';  
    public menuItemId = 'limpieza-general';  

    public override filtering: Filtering<TareaLimpiezaGeneralModel> = new Filtering<TareaLimpiezaGeneralModel>();
public override canShow: Record<string, boolean> = {};
    public override model: TareaLimpiezaGeneralModel = {};

    public form: TareasMtoLimpiezaGeneralFormDefinition | null = null;
    public cols: ColInterface[] = [
        {field: 'cliente_nombre', header: 'Cliente', filter: ''},
        {field: 'trabajadores_nombres', header: 'Empleado', filter: ''},
        {field: 'finca', header: this.fincaName, filter: ''},
        {field: 'fecha', header: 'Fecha', filter: ''},
        {field: 'hora_inicio', header: 'Hora Inicio', filter: ''},
        {field: 'hora_fin', header: 'Hora Fin', filter: ''},
        {field: 'horas_totales', header: 'Horas', filter: ''},
        {field: 'prioridad', header: 'Prioridad/Realizada', filter: ''},
        {field: 'observaciones', header: 'Observaciones', filter: ''}
    ];  

   optionsSelectButton = [
        { label: 'Todos', value: 0 },
        { label: 'Si', value: 1 },
        { label: 'No', value: 2 }
    ];
    
    public readonly realizadoControl = new FormControl<number>(0, { nonNullable: true });
    selectedYears = 0;
    public totalHoras: Moment | string = '00:00';
    public auxTotalHoras: Moment | string = '00:00';
    public fecha: {inicio: string; fin: string} = {
        inicio: '',
        fin: '',
    };

    constructor(public tareasApi: TareasApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, tareasApi.mtoLimpiezaGeneral.GET, tareasApi.mtoLimpiezaGeneral.DELETE);
  
  
    }

    ngOnInit() {
      
        if (environment.features.showTareasMto){
            if (this.rolUser !== 'admin'){
                this.hiddenButtonDelete = true;
            }
            this.realizadoControl.setValue(2);
        }
    
        this.dashboard.setSubmenuItem('tareas', this.menuItemId);
    
        this.filtering.addFilter((copy: TreeNode<TareaLimpiezaGeneralModel>[] | void) => 
            (copy as TreeNode<TareaLimpiezaGeneralModel>[]).filter(row => {
                const tareaLimpieza = row as TareaLimpiezaGeneralModel;

                switch (this.realizadoControl.value) {
                case 1:
                    return ['Realizada'].includes(tareaLimpieza.prioridad ?? '');
                case 2:
                    return !['Realizada'].includes(tareaLimpieza.prioridad ?? '');
                default:
                    return true;
                }
            }));

        /*** 
   *  En el caso de que el usuario no se admin,
   * filtrará por su id de usuario que coincide,
   *  con el id trabajador   
  */
        if ( StorageManager.getUser().rol !== 'admin' ){ 
            this.filtering.addFilter((copy: TreeNode<TareaLimpiezaGeneralModel>[] | void) => 
                (copy as TreeNode<TareaLimpiezaGeneralModel>[]).filter(row => {
                    const tareaLimpieza = row as TareaLimpiezaGeneralModel;

                    if (tareaLimpieza.ids_trabajadores != null ) {
          
                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaLimpieza.ids_trabajadores as string).split(';');
                        if ( listaTrabajadores.find((id) => id === idTrabajador?.toString()) ) {
                            return true;
                        }
          
                    }
                    return false;
                }));
        }

        /*** 
   *  Fin de filtrar por id_usuario = trabajador,
   *   
  */
        this.filtering.addFilter((copy: TreeNode<TareaLimpiezaGeneralModel>[] | void) => 
            (copy as TreeNode<TareaLimpiezaGeneralModel>[]).filter(row => {
                const tareaLimpieza = row as TareaLimpiezaGeneralModel;

                if (this.fecha.inicio && this.fecha.fin && tareaLimpieza.fecha) {

                    const arrayFecha = tareaLimpieza.fecha.toString().split('/');
                    const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];

                    if (
                        (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                    (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }

            }));
    }

    ngAfterViewInit() {
        this.tareasApi.mtoLimpiezaGeneral.GET.response(() => {
            this.updateFooter();
            this.sum();
        });
    }

    public add() {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-' + this.pathToForm]);
        }
    }
  
    public edit(data: TareaLimpiezaGeneralModel) {
        this.router.navigate(['dashboard', 'editar-limpieza-general', data.id]);
    }
  
    public duplicate(data: TareaLimpiezaGeneralModel) {
        this.router.navigate(['dashboard', 'duplicar-limpieza-general', data.id]);
    }  

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }  
    public override show(modal: string, data: TareaLimpiezaGeneralModel): void {
        const modalData = { ...data } as TareaLimpiezaGeneralModel;
        this.coerceSwitchFields(modalData);
        super.show(modal, modalData);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new TareasMtoLimpiezaGeneralFormDefinition(formType, modalData);
    }

    public override hide(modal: string) {
        this.model = {};
        this.form = null;
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    private coerceSwitchFields(data: TareaLimpiezaGeneralModel): void {
        const switchFields = [
            'mantenimiento',
            'limpieza_calles',
            'bolsas_basura',
            'limpieza_desagues',
        ];

        for (const fieldName of switchFields) {
            data[fieldName] = TRUTHY_VALUES.includes(data[fieldName]?.toString() ?? '');
        }
    }

    public globalConditionalStyle(value: any, col: ColInterface): ColStylesInterface {
        if ( col.field === 'horas_totales') {
            return {
                textAlign: 'center'
            };
        }
        if (col.field === 'prioridad') {
            if (value === 2) {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },  
                };
            }
            else if (value === 1){
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },  
                };
            }
        }

        if (col.field === 'trabajadores_nombres') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        if (col.field === 'observaciones') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        return {textAlign: 'center'};
    }
  
    public globalVisualTransform(value: string, col: ColInterface) {
        const fieldsSiNo = ['limpieza_calles', 'bolsas_basura', 'limpieza_desagues'];
        if ( fieldsSiNo.includes(col.field)) {
            if ( TRUTHY_VALUES.includes(value) ) {
                return 'Sí';
            } else {
                return 'No';
            }
        }
        return value;
    }
  
    public formatDate(date: string) {
        moment.locale('es');
        return moment(date, 'DD/MM/YYYY').format('LL');
    }  

    filtrar(): void {
        this.filtering.filter();
        this.updateFooter();
    }
    public downloadCsv(): void {
        this.form = new TareasMtoLimpiezaGeneralFormDefinition(+FormType.EXPORT, {});
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as TareaLimpiezaGeneralModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Limpieza general.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }
    }

    public override updateFooter() {
        this.sum();
    }

    public override sum() {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;
        (this.filtering.value || []).forEach((tareas, index ) => {
            const tareaObtained = tareas as TareaLimpiezaGeneralModel;

            if ( tareaObtained.horas_totales != null ) {
   
                if (tareaObtained.horas_totales.length > 0) {
                    contador++;
                    const horaMinuto = (tareaObtained.horas_totales as string).split(':');
                    this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
                }
            }

            if ( index + 1 >= (this.filtering.value as TareaLimpiezaGeneralModel[]).length ){
  
                let minutos = moment(this.totalHoras).format('mm');
      
      
                let differencia = moment(this.totalHoras).diff(this.auxTotalHoras);
      
                if ( minutos.toString().length === 0) {
                    minutos = '00';
                }

                if ( minutos.toString().length === 1) {
                    minutos = '0' + minutos.toString();
                }
                differencia = differencia / (1000 * 60 * 60);
                differencia = Math.abs(Math.floor(differencia));

                this.totalHoras = differencia + ':' + minutos;
      
                if ( contador === 0){
                    this.totalHoras = '00:00';
                }

            }
  
    
        });

        if ( contador === 0){
            this.totalHoras = '00:00';
        }
        this.filtering.filter();
    }

    getFechaInicio(event: string | Date) {
        this.fecha.inicio = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
  
    }
    getFechaFin(event: string | Date) {
        this.fecha.fin = this.getFilterDate(event);
        this.filtering.filter();
        this.updateFooter();
    }

    private getFilterDate(event: string | Date): string {
        const date = event instanceof Date ? moment(event) : moment(event, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

        return date.isValid() ? date.format('YYYY-MM-DD') : '';
    }

}
